import produce from "immer"
import { MtMailTemplate } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initTemplate: MtMailTemplate = {
    name: "",
    description: "",
    subject: "",
    content: "",
    order: 0,
}

const initMailState: types.MailState = {
    settingList: [],
    settingEdit: null,
    reloadSettingList: true,

    templateList: [],
    templateEdit: initTemplate,
    reloadTemplateList: true,
    reloadTemplateEdit: true,
}

const mailReducer = produce((
    draft: types.MailState = initMailState,
    action: ActionTypes = null,
): types.MailState => {
    switch (action.type) {
        case types.MAIL_SETTING_LIST:
            draft.settingList = action.settingList
            return draft

        case types.MAIL_SETTING_EDIT:
            draft.settingEdit = action.setting
            return draft

        case types.MAIL_SETTING_RELOAD_LIST:
            draft.reloadSettingList = action.value
            return draft

        case types.MAIL_TEMPLATE_LIST:
            draft.templateList = action.templateList
            return draft

        case types.MAIL_TEMPLATE_EDIT:
            draft.templateEdit = action.template
            return draft

        case types.MAIL_TEMPLATE_RELOAD_LIST:
            draft.reloadTemplateList = action.value
            return draft

        case types.MAIL_TEMPLATE_RELOAD_EDIT:
            draft.reloadTemplateEdit = action.value
            return draft

        default:
            return draft
    }
})
export default mailReducer
